import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {Validators, FormBuilder, FormGroup, FormControl,AbstractControl } from '@angular/forms';
import { ToastController } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
import { UserData } from '../../providers/user-data'
import { LoginPage } from '../login/login';
/**
 * Generated class for the ChangeForgetPasswordPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-change-forget-password',
  templateUrl: 'change-forget-password.html',
})
export class ChangeForgetPasswordPage {
  changePasswordForm:FormGroup
  tokenForm:FormGroup
  tokenMatch:boolean=false
  constructor(public navCtrl: NavController,private formBuilder: FormBuilder, private toastCtrl: ToastController,
    private alertCtrl:AlertController, private userData:UserData) {
    this.changePasswordForm = this.formBuilder.group({
      userId: ['', Validators.required],
      passwords: this.formBuilder.group({
        newPassword: ['', [Validators.required,Validators.minLength(8)]],
        confirmNewPassword: ['', [Validators.required,Validators.minLength(8)]]
      }, {validator: this.validatePassword}),
    })
    this.tokenForm = this.formBuilder.group({
      token: ['', Validators.required],
    })
  }

  ionViewDidLoad() {
  }

  onTokenSubmit(value){
    this.userData.checkPasswordToken(value.token).subscribe(
      res => {
        if(res['success']){
          this.tokenMatch = true
          this.changePasswordForm.get('userId').setValue(res['data'][0].userid)
        }
      },
      err => {
        if(err['error']['error']){
          this.presentAlert('Error', err['error']['message'])
        }
      }
    )
  }

  onSubmit(value){
    this.userData.changeForgetPassword(value).subscribe(
      res => {
        if(res['success']){
          this.presentToast(res['message'])
          this.navCtrl.push(LoginPage)
        }
      },
      err => {
        this.presentAlert('Error', 'Something went wrong, try again')
      }
    )
  }
  
  validatePassword(formControl: AbstractControl):{[key:string]:boolean} {
    const password = formControl.get('newPassword');
    const confirmpassword = formControl.get('confirmNewPassword');
      if (!password || !confirmpassword) { return null;  }  
      return password.value === confirmpassword.value ? null : { nomatch: true };
    }

    presentToast(msg) {
      let toast = this.toastCtrl.create({
        message: msg,
        duration: 3000,
        position: 'top',
        showCloseButton:true
      });
      toast.present();
    }
  
    presentAlert(title,msg) {
      let alert = this.alertCtrl.create({
        title: title,
        subTitle: msg,
        buttons: ['Dismiss']
      });
      alert.present();
    }
}



// WEBPACK FOOTER //
// ./src/pages/change-forget-password/change-forget-password.ts